import { useEffect, useState } from "react";
import { Menu, CircleX } from "lucide-react";
import { getTicketUrl, trackEvent } from "../config";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => { document.body.style.overflow = ""; };
  }, [menuOpen]);

  function closeMenu() {
    setMenuOpen(false);
  }

  const links = [
    { href: "#crew", label: "Crew" },
    { href: "#tickets", label: "Tickets" },
    { href: "#venue", label: "Venue" },
    { href: "#faq", label: "FAQ" },
  ];

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          scrolled
            ? "py-3 bg-[#050505]/90 backdrop-blur-xl border-b border-white/5"
            : "py-4 md:py-7"
        }`}
      >
        <div className="w-full px-4 md:container md:mx-auto md:px-6 flex items-center justify-between">
          <a href="#hero" className="flex items-center shrink-0">
            <img src="/logo-daaru-desi.png" alt="Daaru Desi Events" className="h-16 md:h-24 w-auto rounded-full ring-2 ring-white/10" />
          </a>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center space-x-10">
            {links.map((l) => (
              <a key={l.href} href={l.href} className="text-md text-gray-400 hover:text-white transition-colors duration-300 tracking-widest uppercase cursor-pointer">
                {l.label}
              </a>
            ))}
          </div>

          <div className="flex items-center gap-4 shrink-0">
            <a
              href={getTicketUrl("nav_cta")}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackEvent("InitiateCheckout")}
              className="inline-flex items-center justify-center px-4 py-2 md:px-6 md:py-2.5 rounded-full text-xs md:text-sm font-semibold bg-[#C9ED00] text-black hover:bg-[#d6f800] hover:scale-105 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Get Tickets
            </a>

            {/* Mobile hamburger */}
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="md:hidden w-11 h-11 flex items-center justify-center cursor-pointer"
              aria-label={menuOpen ? "Close menu" : "Open menu"}
              aria-expanded={menuOpen}
            >
              {menuOpen ? (
                <CircleX className="w-7 h-7 text-white" strokeWidth={1.5} />
              ) : (
                <Menu className="w-7 h-7 text-white" strokeWidth={1.5} />
              )}
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile menu overlay */}
      {menuOpen && (
        <div className="fixed inset-0 z-40 bg-[#050505] flex flex-col items-center justify-center gap-8 md:hidden">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={closeMenu}
              className="text-2xl text-white/80 hover:text-[#C9ED00] transition-colors duration-300 font-serif cursor-pointer"
            >
              {l.label}
            </a>
          ))}
          <a
            href={getTicketUrl("mobile_menu")}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => { trackEvent("InitiateCheckout"); closeMenu(); }}
            className="mt-4 px-8 py-3 bg-[#C9ED00] text-black font-semibold rounded-full text-lg cursor-pointer"
          >
            Get Tickets
          </a>
        </div>
      )}
    </>
  );
}
